module.exports = __webpack_public_path__ + "media/images/athletes/1795-1ddf1ba0dbd4e7fb4f014e75c6785425.png";